import DashboardIcon from "@mui/icons-material/Dashboard";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import {MdLockReset} from "react-icons/md";
import RestoOutlineIcon from "@mui/icons-material/FoodBankOutlined";
import StoreIcon from "@mui/icons-material/Store";
import {Link, NavLink} from "react-router-dom";
import BBQImage from "../../app/elements/bbq-image";


const AgentSidebar = () => {
    const getNavClass = ({isActive}) => isActive ? "active-link" : "";

    return (
        <div className="sidebar">
            <div className="top">
                <Link to="/" style={{textDecoration: "none"}}>
                    <BBQImage
                        src="images/BBQ_LOGO.png"
                        alt="#"
                        className="header-logo-login cursor-pointer"
                    />
                </Link>
            </div>

            <hr/>

            <div className="center">
                <ul>
                    <p className="title">MAIN</p>

                    <NavLink
                        to="/agents/dashboard"
                        end
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <DashboardIcon className="icon"/>
                            <span>Dashboard</span>
                        </li>
                    </NavLink>

                    <NavLink
                        to="/agents/config/register"
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <RegisterIcon className="icon"/>
                            <span>Register Business</span>
                        </li>
                    </NavLink>

                    <NavLink
                        to="/agents/config/resetpassword"
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <MdLockReset className="icon"/>
                            <span>Reset Password</span>
                        </li>
                    </NavLink>

                    <NavLink
                        to="/agents/config/restaurants"
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <RestoOutlineIcon className="icon"/>
                            <span>Business Entity</span>
                        </li>
                    </NavLink>

                    <NavLink
                        to="/agents/config/products"
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <StoreIcon className="icon"/>
                            <span>Products</span>
                        </li>
                    </NavLink>

                    <NavLink
                        to="/agents/config/tracking"
                        style={{textDecoration: "none"}}
                        className={getNavClass}
                    >
                        <li>
                            <StoreIcon className="icon"/>
                            <span>Tracking</span>
                        </li>
                    </NavLink>
                </ul>
            </div>
        </div>
    );
};

export default AgentSidebar;
